import { createContext, type ReactNode, useContext, useMemo } from 'react';

interface OrderSearchHighlightContextValue {
  // The committed dispatch omni-search term (TRE-15530). Each card highlights its
  // own rendered strings against this term, and derives its own "why matched"
  // chips (TRE-15532) — the term is the only thing shared across cards, so a
  // realtime mutation to one order never invalidates a store-wide match map.
  searchTerm: string;
}

const OrderSearchHighlightContext = createContext<OrderSearchHighlightContextValue>({
  searchTerm: '',
});

interface OrderSearchHighlightProviderProps {
  children: ReactNode;
  searchTerm?: string | null;
}

export function OrderSearchHighlightProvider({
  children,
  searchTerm,
}: OrderSearchHighlightProviderProps) {
  const value = useMemo(() => ({ searchTerm: searchTerm ?? '' }), [searchTerm]);

  return (
    <OrderSearchHighlightContext.Provider value={value}>
      {children}
    </OrderSearchHighlightContext.Provider>
  );
}

export function useOrderSearchHighlightTerm() {
  return useContext(OrderSearchHighlightContext).searchTerm;
}
